<!--首页-->
<template>
  <div class="home-page mt16">
    <div class="article space-between">
      <div class="left">
        <div
          v-if="topArticleList[0]"
          class="article-main"
          @click="
            toDetails(
              {
                id: topArticleList[0].id,
                title: '首页',
                tag: '最新动态',
              },
              topArticleList[0].linkTo,
            )
          "
        >
          {{ topArticleList[0].title }}
        </div>
        <div class="space-between">
          <div
            v-if="topArticleList[1]"
            class="article-link"
            :title="topArticleList[1].title"
            style="margin-right: 12px"
            @click="
              toDetails(
                {
                  id: topArticleList[1].id,
                  title: '首页',
                  tag: '最新动态',
                },
                topArticleList[1].linkTo,
              )
            "
          >
            [<span class="text_overflow">{{ topArticleList[1].title }}</span
            >]
          </div>
          <div
            v-if="topArticleList[2]"
            class="article-link"
            :title="topArticleList[2].title"
            @click="
              toDetails(
                {
                  id: topArticleList[2].id,
                  title: '首页',
                  tag: '最新动态',
                },
                topArticleList[2].linkTo,
              )
            "
          >
            [<span class="text_overflow">{{ topArticleList[2].title }}</span
            >]
          </div>
        </div>
      </div>
      <div class="right">
        <div class="dynamic-icon">New</div>
        <div class="space-between new-dynamic">
          <div @click="toMore({ title: '首页', tag: '最新动态' })">
            最新动态
          </div>
        </div>
        <ul class="dynamic-ul-li" style="height: 100px; margin-bottom: 0">
          <li
            v-for="(item, i) in newsPresslList.slice(0, 2)"
            :key="i"
            @click="
              toDetails(
                {
                  id: item.id,
                  title: '首页',
                  tag: '最新动态',
                },
                item.linkTo,
              )
            "
          >
            <p class="dynamic-title" :title="item.title">{{ item.title }}</p>
          </li>
        </ul>
      </div>
    </div>

    <div class="carousel space-between">
      <div class="left">
        <el-carousel>
          <el-carousel-item v-for="(item, i) in bannerList" :key="i">
            <div class="carouse-img" @click="onMenuLinkItem(item.url)">
              <img v-if="item.imagePath" :src="path + item.imagePath" alt="" />
              <img src="../assets/images/img_default.webp" v-else alt="" />
              <div class="flex img-title">
                <div class="text_overflow" :title="item.title">
                  {{ item.title }}
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>

    <div class="advert space-between">
      <div class="left">
        <el-carousel height="120px" indicator-position="none">
          <el-carousel-item v-for="(item, i) in themeList" :key="i">
            <div class="party-building-img hover-inter-active" @click="item.url ? onMenuLinkItem(item.url) : onMenuItem('/special-column', '专题专栏')">
              <img :src="path + item.imagePath" alt="" />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="right">
        <div
          class="party-building-img hover-inter-active"
          @click="onMenuItem('/document', '法规文件')"
        >
          <img src="../assets/images/Group1142815672.png" alt="" />
        </div>
      </div>
    </div>

    <div class="news space-between">
      <div class="left">
        <div class="space-between mytab">
          <div class="space-between">
            <div
              :class="{
                'tag-l-selected': currentTabLeft === '工作动态',
                'tag-l': currentTabLeft !== '工作动态',
              }"
              @click="changeTabLeft('工作动态')"
            >
              工作动态
            </div>
            <div
              :class="{
                'tag-r-selected': currentTabLeft === '科普宣传',
                'tag-r': currentTabLeft !== '科普宣传',
              }"
              @click="changeTabLeft('科普宣传')"
            >
              科普宣传
            </div>
          </div>
          <el-link
            :underline="false"
            @click="
              toMore(
                currentTabLeft == '工作动态'
                  ? { title: '中心动态', tag: '中心新闻' }
                  : { title: '中心动态', tag: '科普宣传' },
              )
            "
            class="hover-inter-active"
          >
            更多 <i class="el-icon-d-arrow-right"></i>
          </el-link>
        </div>
        <ul class="news-ul-li" style="height: 422px; margin-bottom: 0; padding-bottom: 0;">
          <li
            class="space-between"
            v-for="(item, i) in currentTabLeft == '工作动态'
              ? newsPressList
              : newsVideoList"
            :key="i"
            @click="onListTitle(item, '中心动态', currentTabLeft)"
          >
            <p class="text_overflow" :title="item.title">{{ item.title }}</p>
            <span>{{
              item.publishedDate
                ? item.publishedDate.split(" ")[0].substring(5)
                : item.createdDate.split(" ")[0].substring(5)
            }}</span>
          </li>
        </ul>
      </div>
      <div class="right">
        <div class="space-between mytab">
          <div class="space-between">
            <div
              :class="{
                'tag-l-selected': currentTabRight === '党建动态',
                'tag-l': currentTabRight !== '党建动态',
              }"
              @click="changeTabRight('党建动态')"
            >
              党建动态
            </div>
            <div
              :class="{
                'tag-r-selected': currentTabRight === '通知公告',
                'tag-r': currentTabRight !== '通知公告',
              }"
              @click="changeTabRight('通知公告')"
            >
              通知公告
            </div>
          </div>
          <el-link
            :underline="false"
            @click="
              toMore(
                currentTabRight == '党建动态'
                  ? { title: '器检党建', tag: '党建动态' }
                  : { title: '中心动态', tag: '通知公告' },
              )
            "
            class="hover-inter-active"
          >
            更多 <i class="el-icon-d-arrow-right"></i>
          </el-link>
        </div>
        <ul class="news-ul-li" style="height: 422px; margin-bottom: 0; padding-bottom: 0;">
          <li
            class="space-between"
            v-for="(item, i) in currentTabRight == '党建动态'
              ? newsBuildingList
              : newsAnnouncementightList"
            :key="i"
            @click="
              onListTitle(
                item,
                currentTabRight == '党建动态' ? '器检党建' : '中心动态',
                currentTabRight,
              )
            "
          >
            <p class="text_overflow" :title="item.title">{{ item.title }}</p>
            <span>{{
              item.publishedDate
                ? item.publishedDate.split(" ")[0].substring(5)
                : item.createdDate.split(" ")[0].substring(5)
            }}</span>
          </li>
        </ul>
      </div>
    </div>

    <!-- <div class="notice space-between">
      <img src="../assets/images/img_5.webp" alt="" class="lb" />
      <span class="font20 el-link">通知公告</span>
      <div class="notice-carousel">
        <el-carousel height="28px" indicator-position="none" arrow="never">
          <el-carousel-item v-for="(item, i) in announcementlList" :key="i">
            <div
              class="space-between pointer font20"
              @click="
                toDetails(
                  {
                    id: item.id,
                    title: '中心动态',
                    tag: tabname,
                  },
                  item.linkTo,
                )
              "
            >
              <p>
                {{ item.title }}
              </p>
              <span>{{
                item.publishedDate
                  ? item.publishedDate.split(" ")[0]
                  : item.createdDate.split(" ")[0]
              }}</span>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <el-link
        :underline="false"
        @click="
          toMore({
            title: '中心动态',
            tag: '通知公告',
            key: 'news.announcement.id',
          })
        "
        class="hover-inter-active"
      >
        更多 <i class="el-icon-d-arrow-right"></i>
      </el-link>
    </div> -->
    <public-service></public-service>
    <friendship-link></friendship-link>
  </div>
</template>
<script>
import {
  getArticleList,
  getlatest,
  getCategory,
  getSlideList,
  getThemeList,
  slideShowList,
  getKey,
} from "@/api/index";
import publicService from "../components/home/public-service.vue";
import friendshipLink from "../components/friendship-link.vue";
import { mapState } from "vuex";

export default {
  name: "home",
  data() {
    return {
      carouselList: [],
      newsPresslList: [],
      newsPressList: [],
      newsBuildingList: [],
      newsVideoList: [],
      newsAnnouncementightList: [],
      announcementlList: [],
      topArticleList: [],
      themeList: [],
      category: [],
      bannerList: [],
      tabname: "",
      currentTabLeft: "工作动态",
      currentTabRight: "党建动态",
    };
  },
  components: { publicService, friendshipLink },
  computed: {
    ...mapState(["menuArr"]),
  },
  activated() {
    this.getArticleList();
    this.getTopArticleList();
  },
  created() {
    this.getCategory();
    this.getlatest();
    this.slideShowList();
    this.getThemeList();
    this.getKey();
    this.getSlideShowList();
    this.getLeftList();
    this.getRightList();
  },
  methods: {
    changeTabLeft(tag) {
      this.currentTabLeft = tag;
    },
    changeTabRight(tag) {
      this.currentTabRight = tag;
    },
    // 获取首页轮播动态
    slideShowList() {
      slideShowList()
        .then((res) => {
          this.bannerList = res.list;
        })
        .finally(() => {});
    },
    getKey() {
      // 动态获取法规文件的tab
      getKey({ key: "news.announcement.id" })
        .then((res) => {
          this.tabname = res.name;
        })
        .finally(() => {});
    },
    // 获取最新动态的分类列表
    getCategory() {
      getCategory()
        .then((res) => {
          this.category = res.list;
        })
        .finally(() => {});
    },
    getThemeList() {
      getThemeList()
        .then((res) => {
          this.themeList = res.list;
        })
        .finally(() => {});
    },
    // 跳转本地
    onMenuItem(path, tag) {
      if (tag == "专题专栏") {
        this.$store.commit("SET_TABS", {
          children: [{ tag: "党建专题", key: "special.column.id" }],
        });
        this.$router.push({
          path,
          query: { title: "首页", tag, key: "special.column.id" },
        });
      } else {
        this.$store.commit("SET_TABS", {
          children: [{ tag: "法规", key: "special.column.id" }],
        });
        this.$router.push({
          path,
          query: { title: "法规文件", tag, key: "regulatory.provision.id" },
        });
      }
    },

    // 跳转第三方链接
    onMenuLinkItem(url) {
      window.open(url, "_blank");
    },
    getArticleList() {
      getArticleList({ key: "news.announcement.id", page: 0, size: 5 })
        .then((res) => {
          // 通知公告
          this.announcementlList = res.list;
        })
        .finally(() => {});
    },
    getTopArticleList() {
      getArticleList({ page: 0, size: 3, isTop: true })
        .then((res) => {
          // 置顶动态
          this.topArticleList = res.list || [];
          if (this.topArticleList.length == 0) {
            getArticleList({ page: 0, size: 3 }).then((res) => {
              this.topArticleList = res.list || [];
            });
          }
        })
        .finally(() => {});
    },
    // 最新动态数据
    getlatest() {
      getlatest()
        .then((res) => {
          res.list.forEach((item, i) => {
            const category = this.category.find(
              (categoryitem) => item.pid == categoryitem.id,
            );
            item["query"] = {
              title: category.title.split("-")[0],
              tag: category.title.split("-")[1],
            };
          });
          this.newsPresslList = res.list;
        })
        .finally(() => {});
    },
    getLeftList() {
      getArticleList({ key: "news.press.id", page: 0, size: 10 })
        .then((res) => {
          this.newsPressList = res.list;
        })
        .finally(() => {});

      getArticleList({ key: "news.video.id", page: 0, size: 10 })
        .then((res) => {
          this.newsVideoList = res.list;
        })
        .finally(() => {});
    },
    onListTitle(item, title, tag) {
      if (item.linkTo) {
        window.open(item.linkTo, "_blank");
      } else {
        this.$router.push({
          path: "/details",
          query: {
            id: item.id,
            title: title,
            tag: tag,
            // key: this.$route.query.key
          },
        });
      }
    },
    getRightList() {
      getArticleList({ key: "party.building.news", page: 0, size: 10 })
        .then((res) => {
          this.newsBuildingList = res.list;
        })
        .finally(() => {});
      getArticleList({ key: "news.announcement.id", page: 0, size: 10 })
        .then((res) => {
          this.newsAnnouncementightList = res.list;
        })
        .finally(() => {});
    },
    // 轮播动态
    getSlideShowList() {
      getSlideList()
        .then((res) => {
          this.carouselList = res.list
            .filter((item) => item.status === true)
            .sort((a, b) => a.orderNo - b.orderNo); // 根据 orderNo 升序排序
        })
        .finally(() => {});
    },
    toDetails(query, linkTo) {
      if (linkTo) {
        window.open(linkTo, "_blank");
      } else {
        this.$router.push({ path: "/details", query });
      }
    },
    // 点击更多
    toMore(query) {
      if (query.tag == "最新动态") {
        this.$router.push({
          path: "/document",
          query: query,
        });
        this.$store.commit("SET_TABS", {
          children: [{ tag: query.tag }],
        });
      } else if (query.tag == "党建动态") {
        this.$router.push({
          path: "/party-building",
          query: { ...query, key: "party.building.news" },
        });
        const arr = this.menuArr.find((item) => item.title == "器检党建");
        this.$store.commit("SET_TABS", {
          children: arr.children,
        });
      } else {
        const key =
          query.tag == "通知公告"
            ? "news.announcement.id"
            : query.tag == "中心新闻"
            ? "news.press.id"
            : "news.video.id";
        this.$router.push({
          path: "/document",
          query: { ...query, key },
        });
        const arr = this.menuArr.find((item) => item.title == "中心动态");
        this.$store.commit("SET_TABS", {
          children: arr.children,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.home-page {
  width: 100%;
  flex: 1;

  .party-building-img {
    width: 100%;
    height: 120px;

    img {
      width: 100%;
      height: 100%;
    }
  }
  .article {
    width: 100%;
    min-height: 100px;
    margin: 24px 0;
    .left {
      margin-right: 16px;
      min-width: 760px;
      height: 100%;
      position: relative;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-top: 20px;
      .article-main {
        font-size: 28px;
        font-weight: bold;
        margin-bottom: 12px;
        color: #0b4ca2;
        cursor: pointer;
        text-align: center;
      }
      .article-main:hover {
        color: #1d76d4;
      }
      .article-link {
        color: #929292;
        font-size: 16px;
        cursor: pointer;
        max-width: 400px;
        display: flex;
        align-items: center;
      }
      .article-link:hover {
        color: #14579e;
      }
    }
    .right {
      width: 330px;
      height: 100%;
      display: flex;
      align-items: center;
      .new-dynamic {
        color: #409eff;
        font-weight: 600;
        padding: 8px;
        border-radius: 4px;
        width: 36px;
        border: 2px solid #409eff;
        cursor: pointer;
      }
      .dynamic-icon {
        background-color: #409eff;
        color: #fff;
        padding: 2px 4px;
        border-radius: 4px;
        font-size: 8px;
        font-weight: bold;
        position: relative;
        bottom: 62px;
        left: 60px;
      }
    }
    .dynamic-title {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 1.5;
    }
  }
  .news {
    width: 100%;
    height: 472px;
    margin: 24px 0;
    .left {
      margin-right: 16px;
      width: 592px;
      height: 100%;
      position: relative;
      flex: 1;
    }
    .right {
      width: 592px;
      height: 100%;
    }
  }

  .carousel {
    width: 100%;
    height: 610px;
    margin: 24px 0;
    .left {
      min-width: 545px;
      height: 100%;
      position: relative;
      flex: 1;
      ::v-deep .el-carousel__container {
        height: 610px !important;
      }
      ::v-deep .el-carousel__indicator.is-active button {
        background-color: #fff;
      }
      ::v-deep .el-carousel__indicators--horizontal {
        left: 85%;
        width: max-content;
        bottom: 2%;
        transform: translateX(0);
        // padding: 2px 2px;
        padding-bottom: 6px;
      }

      ::v-deep .el-carousel__indicator--horizontal {
        padding: 4px 4px;
      }

      ::v-deep .el-carousel__button {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        border: 1px solid #fff;
        background-color: #ffffff40;
        border: none;
      }
      .carouse-img {
        cursor: pointer;
        img {
          height: 610px;
          width: 100%;
          object-fit: cover;
        }
        .img-title {
          height: 66px;
          width: 100%;
          font-size: 18px;
          color: #fff;
          line-height: 46px;
          padding: 0 260px 0 24px;
          background: #00050a60;
          position: absolute;
          bottom: 0;
          z-index: 100;

          .text_overflow {
            margin-bottom: 4px;
            min-width: 260px;
            font-size: 20px;
            display: flex;
            align-items: center;
          }
        }
      }
    }
  }

  .advert {
    width: 100%;
    margin: 24px 0;
    .left {
      margin-right: 16px;
      width: 592px;
      height: 100%;
      position: relative;
      flex: 1;
      ::v-deep .el-carousel__container {
        height: 120px !important;
      }
      ::v-deep .el-carousel__indicator.is-active button {
        background-color: #fff;
      }
      .carouse-img {
        cursor: pointer;
        img {
          height: 120px;
          width: 100%;
          object-fit: cover;
        }
      }
    }
    .right {
      width: 592px;
      height: 100%;
    }
  }

  .notice {
    width: 100%;
    height: 54px;
    background: url(../assets/images/img_4.webp) no-repeat;
    background-size: 100% 100%;
    object-fit: fill;
    margin-bottom: 16px;
    padding: 0 26px;
    align-items: center;
    .lb {
      width: 28px;
      height: 28px;
    }
    .notice-carousel {
      height: 28px;
      flex: 1;
      align-items: center;
      line-height: 28px;
      padding: 0 20px 0 10px;

      p,
      span {
        color: #333333;
      }
    }
    .el-link {
      color: #ff8c00;
    }
  }
  .font20 {
    font-size: 20px;
  }
}
@media screen and (max-width: 768px) {
  .home-page {
    .party-building-img {
      width: 100%;
      height: 100px;
    }
    .news {
      height: auto;
      flex-direction: column;
      margin-bottom: 16px;

      .left {
        width: 100%;
        min-width: 100%;
        margin-right: 0px;
        margin-bottom: 16px;
        ::v-deep .el-carousel__container {
          height: 400px !important;
        }

        ::v-deep .el-carousel__indicator.is-active button {
          background-color: #fff;
        }
        ::v-deep .el-carousel__indicators--horizontal {
          left: calc(100% - 100px);
          height: 46px;
          display: flex;
          align-items: center;
        }

        ::v-deep .el-carousel__button {
          width: 10px;
          height: 10px;
        }
        .carouse-img {
          cursor: pointer;
          .img-title {
            font-size: 18px;
            padding: 0 260px 0 16px;
            .text_overflow {
              min-width: 200px;
            }
          }
        }
      }
      .right {
        width: 100%;
        height: 490px;
      }
    }
    .notice {
      margin: 0 0 16px;
      padding: 0 16px;
    }
  }
}
</style>
